import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { listChangeHistory } from '../Api/ChangeHistory/ChangeHistoryApi';
import { addError } from './Error';
import { ApiAdvancedFilter, PaginatedResponse } from './GeneralStore';

export interface ChangeHistoryRecord {
  id: string;
  recordType: string;
  recordId: string;
  recordTitle: string | null;
  field: string;
  fromValue: string | null;
  toValue: string | null;
  changedAt: string;
  changedByLabel: string | null;
  changedByName: string | null;
  changeSource: string | null;
  revenueChangeCategory: string | null;
  operation: string | null;
  uniqueKey: string;
}

const inboundFetchNumberSubject = new BehaviorSubject<number>(0);
const changeHistorySubject = new BehaviorSubject<PaginatedResponse<ChangeHistoryRecord>>(
  {} as PaginatedResponse<ChangeHistoryRecord>
);
const changeHistoryLoadingSubject = new BehaviorSubject<boolean>(false);

export const getChangeHistorySubject = (): BehaviorSubject<PaginatedResponse<ChangeHistoryRecord>> =>
  changeHistorySubject;
export const getChangeHistoryLoadingSubject = (): BehaviorSubject<boolean> => changeHistoryLoadingSubject;

export const fetchChangeHistory = async (filters?: ApiAdvancedFilter, forceRefresh = false) => {
  const newFetchNumber = inboundFetchNumberSubject.getValue() + 1;
  inboundFetchNumberSubject.next(newFetchNumber);
  if (changeHistorySubject.getValue()?.data?.length > 0 && !forceRefresh) return;
  changeHistoryLoadingSubject.next(true);
  const { data, error } = await listChangeHistory(filters);
  const currentFetchNumber = inboundFetchNumberSubject.getValue();

  if (data && newFetchNumber === currentFetchNumber) {
    addError('change-history', undefined);
    const dataWithUniqueKeys = {
      ...data,
      data: data.data.map((record) => ({
        ...record,
        uniqueKey: `${record.id}-${record.recordType}`
      }))
    };
    changeHistorySubject.next(dataWithUniqueKeys);
  }

  if (error && newFetchNumber === currentFetchNumber) addError('change-history', error.message);

  newFetchNumber === currentFetchNumber && changeHistoryLoadingSubject.next(false);
};
